import { Flex, Image } from "@chakra-ui/react";
import React from "react";
import { COMMON_WEB_PATH } from "../../constant";
import useWebsiteInfo from "../../hook/useWebsiteInfo";

// 定義不同遊戲的圖片配置

const HomeTitle = ({ gameType = "TOP10" }) => {
  const { homeTitleConfigs } = useWebsiteInfo();
  // 獲取對應遊戲類型的配置
  const config = homeTitleConfigs[gameType] || homeTitleConfigs.TOP10;

  return (
    <Flex alignItems={`center`} gap="10px">
      <Image
        src={config.icon1}
        alt={gameType}
        objectFit={"cover"}
        w={{
          base: "30px",
          md: "50px",
        }}
      />
      <Image
        src={config.icon2}
        alt={gameType}
        h={{
          base: "30px",
          md: "50px",
        }}
      />
    </Flex>
  );
};
export default HomeTitle;
